<div class="wrapper">

    <div class="header pb-2">
        <h3 class="mb-0" mat-dialog-title>{{data.heading}}</h3>
        <button mat-icon-button (click)="close(false)">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="infoSection" *ngIf="data?.type=='success'">
        <img src="assets/ok-status.png" alt="">
    </div>
    <mat-dialog-content>
        <p [ngClass]="{'error': data.type==='error'}" class="text-center mb-0">
            {{data.message}}
        </p>
    </mat-dialog-content>

    <mat-dialog-actions class="pb-4">
        <button mat-button (click)="close(false)" class="doc-btn-success" *ngIf="data.showCancelBtn">Cancel</button>
        <button mat-button (click)="close(true)" class="doc-btn-success">{{data.buttonText}}</button>
    </mat-dialog-actions>

</div>